import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box
} from '@mui/material';
import { Close } from '@mui/icons-material';
import isElectron from '../../Utils/isElectron';

const ImageOverlay = ({ open, onClose, imageSrc, title }) => {
  // Fix image path for Electron - construct proper file:// URL
  const getImageSrc = () => {
    if (!imageSrc) return '';
    
    // If already a full URL, return as-is
    if (imageSrc.startsWith('http://') || imageSrc.startsWith('https://') || imageSrc.startsWith('file://')) {
      return imageSrc;
    }
    
    // For Electron, construct proper file:// URL based on window.location
    if (isElectron()) {
      // Get the base path from window.location (e.g., file:///path/to/app/build/)
      const basePath = window.location.origin + window.location.pathname.replace(/\/[^/]*$/, '');
      // Construct the full path to the image
      const imagePath = imageSrc.startsWith('/') ? imageSrc : `/${imageSrc}`;
      return `${basePath}${imagePath}`;
    }
    
    // For web, use as-is (React handles public folder paths)
    return imageSrc;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#f5f5f5',
          borderRadius: 0
        }
      }}
    >
      <DialogTitle sx={{
        m: 0,
        p: 2,
        backgroundColor: '#fff',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Box component="span" sx={{ fontWeight: 600, color: '#2e2e2e' }}>
          {title}
        </Box>
        <IconButton
          onClick={onClose}
          sx={{ color: '#2e2e2e' }}
          size="small"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ 
        p: 3, 
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <Box
          component="img"
          src={getImageSrc()}
          alt={title}
          sx={{
            maxWidth: '100%',
            height: 'auto',
            width: '100%',
            display: 'block'
          }}
          onError={(e) => {
            console.error('[ImageOverlay] Failed to load image:', getImageSrc());
            console.error('[ImageOverlay] Original src:', imageSrc);
            console.error('[ImageOverlay] isElectron:', isElectron());
            console.error('[ImageOverlay] PUBLIC_URL:', process.env.PUBLIC_URL);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageOverlay;
